import React from "react";
import Echarts from "echarts";
import "echarts-liquidfill/dist/echarts-liquidfill";

class Wave extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initEcharts();
  }

  initEcharts = () => {
    this.myChart = Echarts.init(document.getElementById("echarts-wave-dom"));
    this.chartOption = {
      series: [
        {
          type: "liquidFill",
          radius: "85%",
          waveAnimation: true,
          clickable: false,
          data: [
            {
              value: 0,
              direction: "left",
              itemStyle: {
                normal: {
                  color: "#7CE461",
                },
              },
            },
          ],
          outline: {
            // show: true , //是否显示轮廓 布尔值
            borderDistance: 1, // 外部轮廓与图表的距离 数字
            itemStyle: {
              borderColor: "#1DBF41", // 边框的颜色
              borderWidth: 3, // 边框的宽度
              // shadowBlur: 5 , //外部轮廓的阴影范围 一旦设置了内外都有阴影
              shadowColor: "#1DBF41", // 外部轮廓的阴影颜色
            },
          },
          itemStyle: {
            opacity: 0.9, // 波浪的透明度
            shadowBlur: 0, // 波浪的阴影范围
          },
          backgroundStyle: {
            color: "rgba(62, 233, 126, 0.06)", // 图表的背景颜色
          },
          label: {
            // 数据展示样式
            show: true,
            color: "#1DBF41",
            insideColor: "#fff",
            fontSize: 60,
            fontWeight: 400,
            align: "center",
            baseline: "middle",
            position: "inside",
            formatter: (item) => {
              return `${Math.round(item.value * 100)}%`;
            },
          },
        },
      ],
    };

    this.myChart.setOption(this.chartOption);
  };

  /**
   * 设置图标配置项, 暴露给父组件
   *  options：
   * color: string, // 波浪颜色
   * value: Number,
   * unit: String，
   * bgColor: String, // 背景色 rgba值
   * borderColor: String, // 边框色
   */
  setOptions = (options) => {
    this.chartOption = {
      ...this.chartOption,
      series: [
        {
          ...this.chartOption.series[0],
          data: [
            {
              ...this.chartOption.series[0].data[0],
              value: options.value,
              itemStyle: {
                normal: {
                  color: options.color,
                },
              },
            },
          ],
          outline: {
            ...this.chartOption.series[0].outline,
            itemStyle: {
              ...this.chartOption.series[0].outline.itemStyle,
              borderColor: options.borderColor,
              shadowColor: options.borderColor,
            },
          },
          label: {
            ...this.chartOption.series[0].label,
            color: options.borderColor,
            formatter: (item) => {
              return `${Math.round(item.value * 100)}${options.unit}`;
            },
          },
          backgroundStyle: {
            color: options.bgColor,
          },
        },
      ],
    };
    this.myChart.setOption(this.chartOption);
  };

  render() {
    const style = {
      width: "100%",
      height: "100%",
    };
    return (
      <div style={{ ...style, position: "relative" }}>
        <div id='echarts-wave-dom' style={style}></div>
        {/** 覆盖canvas,防止点击，触发颜色bug */}
        <div style={{ position: "absolute", zIndex: "9999", top: "0", ...style }}></div>
      </div>
    );
  }
}

export default Wave;



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/wave.js